// extracted by mini-css-extract-plugin
export var dataCell = "_oj-2";
export var dataRow = "_oj-0";
export var headerRow = "_oj-1";